//stage
//export const BASE_IMG_URL = 'https://stsignostagewesteu001.blob.core.windows.net/signo-web-images-storage/';
const BASE_IMG_URL = window._env_.REACT_APP_BASE_IMG_URL;
//LOGOS
export const LOGO_HORZ_ENDOSO = BASE_IMG_URL + 'Logo_Signo_Endoso_Horiz.svg';
export const LOGO_HORZ = BASE_IMG_URL + 'Logo_Signo_Horiz.svg';
export const LOGO_VERT_ENDOSO = BASE_IMG_URL + 'Logo_Signo_Endoso_Vert.svg';
export const LOGO_CONVERSIA_NARANJA = BASE_IMG_URL + 'Logo_Conversia_.svg';
//NEW IMAGES
export const ELIPTICA_LOGIN = BASE_IMG_URL + 'Eliptica_Registro.svg';
export const ELIPTICA_DASHBOARD = BASE_IMG_URL + 'Eliptica_FormMEDIAS.svg';
export const ISOTIPO = BASE_IMG_URL + 'Isotipo.svg';
export const ELIPTICA_BIENVENIDA = BASE_IMG_URL + 'Eliptica_Bienvenida.svg';
//NEW SVGS Import as component
export { default as PersonIcon } from './svgs/PersonIcon';
export { default as LockIcon } from './svgs/LockIcon';
export { default as JornadaLaboralIcon } from './svgs/JornadaLaboralIcon';
export { default as LegalitasIcon } from './svgs/LegalitasIcon';
export { default as LSSIIcon } from './svgs/LSSIIcon';
export { default as MedidasIgualdadIcon } from './svgs/MedidasIgualdadIcon';
export { default as PBCIcon } from './svgs/PBCIcon';
export { default as PRLIcon } from './svgs/PRLIcon';
export { default as PRPIcon } from './svgs/PRPIcon';
document.documentElement.style.setProperty('--bg-login-url', `url(${BASE_IMG_URL}bg_login.jpg)`);
document.documentElement.style.setProperty('--bg-dashboard-section-2-url', `url(${BASE_IMG_URL}software_normativo_de_conversia_signo_PresentacionPPT_2.jpg)`);
document.documentElement.style.setProperty('--bg-claim-login', `url(${ELIPTICA_LOGIN})`);
const images = {
    //en uso
    iconHome: BASE_IMG_URL + 'Icon_Home.svg',
    doc: BASE_IMG_URL + 'doc.svg',
    notes: BASE_IMG_URL + 'notes.svg',
    closeSession: BASE_IMG_URL + 'CloseSession.svg',
    userProfile: BASE_IMG_URL + 'userProfile.svg',
    imgError: BASE_IMG_URL + 'Img_Error.svg',
    imgCard: BASE_IMG_URL + 'card.svg',
    actFillAndSign: BASE_IMG_URL + 'tareaFirma.svg',
    actReadAndCheck: BASE_IMG_URL + 'Info-action.svg',
    actActionsToImplement: BASE_IMG_URL + 'tareaImplementacion.svg',
    actSendAndSign: BASE_IMG_URL + 'tareaComunicaciones.svg',
    banner_dashboard_1: BASE_IMG_URL + 'signo_software_proteccion_de_datos_garantias_de_servicio.jpg',
    banner_dashboard_3: BASE_IMG_URL + 'shutterstock_628142273_R.jpg',
    big_check: BASE_IMG_URL + 'big_check.svg',
    success: BASE_IMG_URL + 'success.svg',
    info_contained: BASE_IMG_URL + 'info_contained.svg',
    form: BASE_IMG_URL + 'Form.svg',
    close: BASE_IMG_URL + 'close.svg',
    info: BASE_IMG_URL + 'info.svg',
    //summaryFormOLD
    headerSummaryFormPdf: BASE_IMG_URL + 'cabecera_summary_form_pdf.jpg',
    arrowTop: BASE_IMG_URL + 'arrowTop.svg',
    arrowBottom: BASE_IMG_URL + 'arrowBottom.svg',
    arrowRight: BASE_IMG_URL + 'arrowRight.svg',
    editResponse: BASE_IMG_URL + 'edit-response.svg',
    //dashboard
    img_formacion: BASE_IMG_URL + 'img_formacion.jpg',
    //Dashboard Normatives
    JornadaLaboralIcon: BASE_IMG_URL + 'Icon_JornadaLaboral.svg',
    LegalitasIcon: BASE_IMG_URL + 'Icon_Legalitas.svg',
    LSSIIcon: BASE_IMG_URL + 'Icon_LSSI.svg',
    MedidasIgualdadIcon: BASE_IMG_URL + 'Icon_Medidas.svg',
    PBCIcon: BASE_IMG_URL + 'Icon_PBC.svg',
    PRLIcon: BASE_IMG_URL + 'Icon_PRL.svg',
    PRPIcon: BASE_IMG_URL + 'Icon_PRP.svg',
    CanalDenunciasIcon: BASE_IMG_URL + 'Icon_CanalDenuncias.svg',
    DPDIcon: BASE_IMG_URL + 'Icon_DPD.svg',
    FacturaElecIcon: BASE_IMG_URL + 'Icon_FacturaElec.svg',
    //swipper navigation
    IconSwipperNavLeft: BASE_IMG_URL + 'Icon_swipper-nav-left.svg',
    IconSwipperNavRight: BASE_IMG_URL + 'Icon_swipper-nav-right.svg',
    //OLD
    INFO_ICON_WHITE: BASE_IMG_URL + 'Icono_26x26_Informacion_blanco_Signo.png',
    INFO_ICON_BLUE: BASE_IMG_URL + 'Icono_102 × 102_Informacion_azul_Signo.png',
};
export default images;
